import { MenuIcon } from 'components/icons/MenuIcon'

const FloatingMenuButtonComponent: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: '8px',
        left: '8px',
        zIndex: 1,
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <button
        onClick={onClick}
        data-testid='nav-icon-testid'
        style={{
          backgroundColor: 'white',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
          border: 'none',
          padding: 0,
          margin: 0,
        }}
      >
        <MenuIcon />
      </button>
    </div>
  )
}

export default FloatingMenuButtonComponent
